import React from "react";
import ReactGA from "react-ga";
import { useIsMobile } from "../../hooks/mobile.js";
import AsyncSelect from "react-select/async";

const TYPE_LABELS = {
    topic: "Topics",
    keyword: "Keywords",
    "sub-theme": "Sub-themes",
    theme: "Themes",
    opportunity: "Opportunities",
};

ReactGA.initialize("UA-11963560-5");

export default function SearchInput(props) {
    const { placeholder, options, handleFilterAndSearch, searchState } = props;
    const isMobile = useIsMobile();

    const filterSearchOptions = React.useCallback(
        inputValue => {
            if (options) {
                const filteredOptions = options.filter(i => {
                    return (
                        i.label.toString().toLowerCase().includes(inputValue.toLowerCase()) ||
                        i.value.toString().toLowerCase().includes(inputValue.toLowerCase())
                    );
                });
                const filteredTypes = [...new Set(filteredOptions.map(d => d.type))];

                return filteredTypes.map(d => {
                    return {
                        label: TYPE_LABELS[d],
                        options: filteredOptions.filter(f => f.type === d),
                    };
                });
            }
            return [];
        },
        [options]
    );

    const loadOptions = (inputValue, callback) => {
        setTimeout(() => {
            callback(filterSearchOptions(inputValue));
        }, 1000);
    };

    const handleInputChange = newValue => {
        if (newValue) {
            ReactGA.event({
                category: "SCIKNOW: search opportunities",
                action: "searchTerm",
                label: newValue,
            });
            return newValue;
        }
    };

    return (
        <AsyncSelect
            aria-label={`Options for ${placeholder}`}
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions
            onInputChange={handleInputChange}
            onChange={handleFilterAndSearch}
            placeholder={placeholder}
            isClearable
            value={searchState}
            styles={{
                placeholder: provided => ({
                    ...provided,
                    fontSize: isMobile ? "14px" : "18px",
                    color: "#707070",
                }),
            }}
        />
    );
}
